import { RouteName } from '@/shared/enums';

export default {
  computed: {
    isSearchView() {
      return this.$route.name === RouteName.SEARCH;
    },
  },
  methods: {
    search(query) {
      const method = this.isSearchView ? 'replace' : 'push';

      this.$router[method]({
        name: RouteName.SEARCH,
        query: { query },
      });
    },
  },
};
